export function debounce(func, wait) {
  // 保存定时器的引用
  let timeout;

  // 返回的函数是用户实际调用的函数，它包含了防抖逻辑
  return function (...args) {
    const context = this;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(function () {
      func.apply(context, args);
    }, wait);
  };
}

export function throttle(func, limit) {
  let inThrottle = false;

  return function (...args) {
    const context = this; // 保存当前的 this 上下文

    if (!inThrottle) {
      // 执行传入的函数
      func.apply(context, args);
      inThrottle = true; // 标记为正在节流

      // 使用闭包和 setTimeout 来在指定的延迟后重置 inThrottle
      setTimeout(() => {
        inThrottle = false; // 重置节流状态
      }, limit);
    }
  };
}
